<template>
  <div class="content" >
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>{{ textTitle }}</span>
    </div>
    <!-- end of title -->

    <el-form label-width="170px" ref="scroll_content">
      <!-- start of 基本信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基本信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <!-- 企业名称 -->
              <el-form-item label="企业名称" prop="tenantName">
                <span slot="label" style="color: red">*</span>
                <span slot="label">公司名称 </span>
                <el-input class="w300" size="small" maxlength="50" placeholder="最多可输入50个字" v-model.trim="tenantName"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司简称 -->
              <el-form-item label="公司简称" prop="abbreviation">
                <span slot="label" style="color: red">*</span>
                <span slot="label">公司简称 </span>
                <el-input class="w300" size="small" maxlength="50" placeholder="最多可输入50个字" v-model.trim="abbreviation"> </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司类型 -->
              <el-form-item label="公司类型" prop="enterpriseCate">
                <span slot="label" style="color: red">*</span>
                <span slot="label">公司类型 </span>
                <el-select class="w300" size="small" v-model="enterpriseCate" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in getCodeListByKey('上游客户分类')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 会员状态 -->
              <el-form-item label="账号类型" prop="memberStatus">
                <span slot="label" style="color: red">*</span>
                <span slot="label">账号类型</span>
                <el-select class="w300" size="small" v-model="memberStatus"  placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('账号类型')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司成立时间 -->
              <el-form-item label="公司成立时间">
                <span slot="label" style="color: red"> </span>
                <span slot="label">公司成立时间</span>
                
                <el-date-picker
                  class="pickerDate"
                  size="small"
                  v-model="dataList.registerDate"
                  type="date"
                  placeholder="请选择企业创立时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 注册资本（万元） -->
              <el-form-item label="注册资本（万元）" prop="registerCapitalAmount">
                <span slot="label" style="color: red"> </span>
                <span slot="label">注册资本（万元）</span>
                <el-input
                  class="w300"
                  size="small"
                  placeholder="请输入"
                  @input="dataList.registerCapitalAmount = dataList.registerCapitalAmount.replace(/[^\d\-\d]/g, '')"
                  v-model.trim="dataList.registerCapitalAmount"
                  maxlength="9"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 年销售额 -->
              <el-form-item label="年销售额" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">年销售额</span>
                <el-select class="w300" size="small" v-model="dataList.salesScaleAmount" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('年销售额')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 是否上市 -->
              <el-form-item label="是否上市">
                <span slot="label" style="color: red"> </span>
                <span slot="label">是否上市</span>
                <el-select class="w300" size="small" v-model="dataList.isIpo" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('是否')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司组织形式 -->
              <el-form-item label="公司组织形式" prop="organizationForm">
                <span slot="label" style="color: red"> </span>
                <span slot="label">公司组织形式</span>
                <el-select class="w300" size="small" v-model="dataList.organizationForm" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('公司组织形式')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 行业地位 -->
              <el-form-item label="行业地位" prop="hydw">
                <span slot="label" style="color: red"> </span>
                <span slot="label">行业地位</span>
                <el-select class="w300" size="small" v-model="dataList.industryPosition" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('行业地位')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 经营规模 -->
              <el-form-item label="经营规模" prop="jygm">
                <span slot="label" style="color: red"> </span>
                <span slot="label">经营规模</span>
                <el-select class="w300" size="small" v-model="dataList.businessScale" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('经营规模')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 经营范围 -->
              <el-form-item label="经营范围" prop="jyfwList">
                <span slot="label" style="color: red"> </span>
                <span slot="label">经营范围</span>
                <el-select class="w300" size="small" v-model="dataList.businessScopeList" multiple placeholder="请选择，可多选">
                  <el-option v-for="item in getCodeListByKey('经营范围')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 主营品种类型 -->
              <el-form-item label="主营品种类型" prop="mainProductCategoryList">
                <span slot="label" style="color: red"> </span>
                <span slot="label">主营品种类型</span>
                <el-select class="w300" size="small" v-model="dataList.mainProductCategoryList" multiple placeholder="请选择，可多选">
                  <el-option v-for="item in getCodeListByKey('推广品类')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 主营下游客户 -->
              <el-form-item label="主营下游客户" prop="zyxykh">
                <span slot="label" style="color: red"> </span>
                <span slot="label">主营下游客户</span>
                <el-select class="w300" size="small" v-model="dataList.downstreamCustomer" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('平台企业类型')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 主营业务类型 -->
              <el-form-item label="主营业务类型" prop="businessTypeList">
                <span slot="label" style="color: red"> </span>
                <span slot="label">主营业务类型</span>
                <el-select class="w300" size="small" v-model="dataList.businessTypeList" multiple placeholder="请选择，可多选">
                  <el-option v-for="item in getCodeListByKey('主营业务类型')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 营销费用年支出额度 -->
              <el-form-item label="营销费用年支出额度" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">营销费用年支出额度</span>
                <el-select class="w300" size="small" v-model="dataList.marketingExpenseYearPayLimit" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('营销费用年支出额度')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司营销费用支出对象 -->
              <el-form-item label="公司营销费用支出对象" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">公司营销费用支出对象</span>
                <el-select class="w300" size="small" v-model="dataList.marketingExpensePayObject" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('公司营销费用支出对象')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 开票类型 -->
              <el-form-item label="开票类型" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">开票类型</span>
                <el-select class="w300" size="small" v-model="dataList.invoiceType" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('发票选项')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 业务员类型 -->
              <el-form-item label="业务员类型" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">业务员类型</span>
                <el-select class="w300" size="small" v-model="dataList.staffTypeList" multiple placeholder="请选择，可多选">
                  <el-option v-for="item in getCodeListByKey('业务员类型')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 业务人员日常拜访对象 -->
              <el-form-item label="业务人员日常拜访对象" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">业务人员日常拜访对象</span>
                <el-select class="w300" size="small" v-model="dataList.staffVisitObjectList" multiple placeholder="请选择，可多选">
                  <el-option v-for="item in getCodeListByKey('客户类型')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司法人 -->
              <el-form-item label="公司法人" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">公司法人</span>
                <el-input
                  class="w300"
                  size="small"
                  placeholder="请输入"
                  @input="dataList.juridicalPerson = dataList.juridicalPerson.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g, '')"
                  @blur="blurName(dataList.juridicalPerson,1)"
                  v-model.trim="dataList.juridicalPerson"
                  maxlength="10"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 司法官司 -->
              <el-form-item label="司法官司" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">司法官司</span>
                <el-select class="w300" size="small" v-model="dataList.stainType" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('司法官司')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 是否有信息部 -->
              <el-form-item label="是否有信息部" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">是否有信息部</span>
                <el-select class="w300" size="small" v-model="dataList.hasItDept" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('是否')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 信息能力 -->
              <el-form-item label="信息能力" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">信息能力</span>
                <el-select class="w300" size="small" v-model="dataList.itAbility" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('高中低')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 对接系统 -->
              <el-form-item label="对接系统" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">对接系统</span>
                <el-select class="w300" size="small" v-model="dataList.linkSystemList" multiple placeholder="请选择，可多选">
                  <el-option v-for="item in getCodeListByKey('对接系统')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 客户定级 -->
              <el-form-item label="客户定级" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">客户定级</span>
                <el-select class="w300" size="small" v-model="dataList.customerGrade" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('客户定级')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 流通类型 -->
              <el-form-item label="流通类型" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">流通类型</span>
                <el-select class="w300" size="small" v-model="dataList.circulateType" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in getCodeListByKey('流通类型')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 上级企业 -->
            <el-col :span="12">
              
              <el-form-item label="上级企业" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">上级企业</span>
                <el-select class="w300" size="small" v-model="dataList.parentTenantGuid" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in tableData1" 
                    :key="item.guid"
                    :label="item.tenantName"
                    :value="item.tenantGuid">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <!-- 公司税号 -->
            <el-col :span="12">
              <el-form-item label="税号">
                <span slot="label" style="color: red"> </span>
                <span slot="label">税号 </span>
                <el-input class="w300" size="small" placeholder="请输入" v-model="formData.taxpayerId"> </el-input>
              </el-form-item>
            </el-col>
            <!-- 企业标签 -->
            <el-col :span="12">
              <el-form-item label="企业标签">
                <span slot="label" style="color: red">*</span>
                <span slot="label">企业标签 </span>
                <el-input class="w300" size="small" placeholder="请输入" v-model="tenantTag"> </el-input>
              </el-form-item>
            </el-col>
            <!-- 产品规则 -->
            <el-col :span="12">
              <el-form-item label="产品规则">
                <span slot="label" style="color: red"></span>
                <span slot="label">产品规则 </span>
                <el-select class="w300" size="small" v-model="productRule" placeholder="请选择，可多选" multiple >
                  <el-option v-for="item in getCodeListByKey('产品规则')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
              <!-- 任务定价模式 -->
              <el-col :span="12">
              <el-form-item label="任务定价模式">
                <span slot="label" style="color: red">*</span>
                <span slot="label">任务定价模式 </span>
                <el-select class="w300" size="small" v-model="taskPriceModel" placeholder="请选择"  >
                  <el-option v-for="item in getCodeListByKey('任务定价模式')" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <!-- 核算周期 -->
            <el-col :span="12" class="account-class">
              <!-- 核算周期 -->
              <el-form-item label="核算周期"  >
                
                  <span slot="label" style="color: red"> </span>
                  <span slot="label">核算周期</span>
                
                
              </el-form-item>
              <div class="acountMountClass">
                  <el-radio v-model="dataList.accountCycle" label="自然月">自然月</el-radio>
                  <div class="account-radio-class">
                    <el-radio v-model="dataList.accountCycle" label="核算月">核算月，核算截止日为 
                    
                  </el-radio>
                  <el-input
                      style="width:80px"
                      size="small"
                      placeholder="1 ~ 31"
                      @input="dataList.accountDeadline = dataList.accountDeadline.replace(/[^\d\-\d]/g, '')"
                      v-model.trim="dataList.accountDeadline"
                      maxlength="2"
                      :disabled="disabledInput"
                      @blur="accountDeadlineBlur"
                    >
                  </el-input>
                  <span  style="color: red">
                    （示例：8月26日-9月25日，核算截止日填写 25）
                  </span>
                  </div>
                  
              </div>
            </el-col>

             <!-- 项目运营经理 -->
            <el-col :span="12">
              <el-form-item label="项目运营经理">
                <span slot="label" style="color: red">*</span>
                <span slot="label">项目运营经理 </span>
                <div style="text-align: left">
                <span class="designee" v-if="projectManagerName">
                  <span class="select-name">{{ projectManagerName }}</span>
                  <span @click="delPM()" class="ml10 cursor-sty font-S19">×</span>
                </span>
                <span class="select-department" @click="choosePerson">
                  {{ projectManagerName ? '修改' : '指定运营经理' }}</span>
              </div>
              </el-form-item>
            </el-col>
          </el-row>
          
        </div>
      </div>
      <!-- end of 基础信息 -->
      <!-- start of 联系方式 -->
      <div class="back-color-fff form-box">
        <span class="form-title">联系方式</span>
        <div class="form-item-box">
          <el-row>
            <!-- 企业联系人 -->
            <el-col :span="12">
              <el-form-item label="业务联系人" prop="contacts">
                <span slot="label" style="color: red">*</span>
                <span slot="label">业务联系人 </span>
                <el-input
                  class="w300"
                  size="small"
                  
                  placeholder="请输入"
                  @input="formData.contacts = formData.contacts.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g, '')"
                  @blur="blurName(formData.contacts,2)"
                  v-model.trim="formData.contacts"
                  maxlength="8"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <!-- 联系电话 -->
            <el-col :span="12">
              <el-form-item label="业务联系人电话" prop="abbreviation">
                <span slot="label" style="color: red">*</span>
                <span slot="label">业务联系人电话 </span>
                <el-input
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  class="w300"
                  size="small"
                  placeholder="请输入"
                  v-model.trim="formData.contactTel"
                  :maxlength="20"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 公司电话 -->
            <el-col :span="12">
              <el-form-item label="企业电话">
                <span slot="label" style="color: red">*</span>
                <span slot="label">公司电话 </span>
                <el-input
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  :maxlength="20"
                  class="w300"
                  size="small"
                  placeholder="请输入"
                  v-model="formData.tel"
                  
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 企业地址 -->
            <el-col :span="12">
              <el-form-item label="企业地址" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">所在省市区 </span>
                <el-cascader
                  class="w300"
                  size="small"
                  ref="cascaderFirst"
                  v-model="addressList"
                  :options="options"
                  @change="incres"
                ></el-cascader>
              </el-form-item>
            </el-col>
            
            
            

            <!-- 税号 -->
            <!-- <el-col :span="12">
              <el-form-item label="税号">
                <span slot="label" style="color: red">*</span>
                <span slot="label">税号 </span>
                <el-input class="w300" size="small" placeholder="请输入" v-model="formData.taxpayerId"> </el-input>
              </el-form-item>
            </el-col> -->

            
            
           
          </el-row>
          <el-row style="margin-top: 5px;">
            <!-- 标注位置 -->
            <el-col :span="12">
              <el-form-item label="标注位置" prop="markers">
                <span slot="label" style="color: red">*</span>
                <span slot="label">标注位置 </span>
            <div class="map-a-sty" v-if="!formData.markers" @click="showMap"><i class="el-icon-plus"></i> 选择地图</div>
            <div v-if="formData.markers" class="map-a-sty" @click="showMap"><i class="el-icon-plus"></i> 重新选择</div>
            <div v-if="formData.markers && formData.markers.lat">
              纬度：{{ formData.markers.lat || ''}}，
              纬度：{{ formData.markers.lng || ''}}</div>
            <div class="fontC-4fa1a4">提示：请确认定位准确，以免影响客户拜访定位</div>
          </el-form-item>
            </el-col>
            
            
            <!-- 详细地址 -->
            <el-col :span="12">
              
              <el-form-item label="详细地址" >
                <span slot="label" style="color: red">*</span>
                <span slot="label">详细地址 </span>
                <el-input
                  class="w300"
                  placeholder="请输入"
                  v-model.trim="formData.address"
                  type="textarea"
                  :rows="2"
                  resize="none"
                  maxlength="100"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 联系方式 -->
      <!-- start of 银行信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">开户行信息</span>
        <el-popover trigger="hover" width="200" placement="top-start">
            <div>{{ '影响上游结算时银行信息选择' }}</div>
            <template slot="reference">
              <i class="el-icon-question"></i>
            </template>
        </el-popover>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <el-row style="padding: 10px 35px">
            <div class="sub-title" >
            <span>开户行信息{{ index + 1 }}</span>
            
            
            <div style="display: flex">
              <div v-if="item.guid">
                <el-button type="default" size="mini" v-if="item.bizState=='S'" @click="enableBankItem(item, 'Y')"
                  >启用</el-button
                >
                <el-button type="default" size="mini" v-else @click="enableBankItem(item, 'S')"
                v-loading.fullscreen.lock="fullscreenLoading"
                  >停用</el-button
                >
              </div>
                
                <div style="position: relative">
                  <el-button
                    class="sub-operate-add2"
                    type="defalut"
                    size="mini"
                    v-show="index === 0"
                    @click="addBankItem"
                    >新增</el-button
                  >
                  <el-button v-show="formData.bankList.length>1" type="danger" size="mini" @click="delBankItem(item,index)">删除</el-button>
                </div>
              </div>
          </div>
          </el-row>
          
          <el-row>
            <!-- 账户类型-->
            <el-col :span="12">
              
              <el-form-item label="账户类型">
                <el-select  class="w300" size="small" :disabled="item.bizState=='S'" clearable v-model="item.accountType" placeholder="请选择" filterable >
                  <el-option
                  v-for="item in getCodeListByKey('账户类型')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
             <!-- 开户银行 -->
            <el-col :span="12">
             
              <el-form-item label="开户银行">
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  :disabled="item.bizState=='S'" 
                  v-model="item.bankName"
                  :maxlength="50"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            
          </el-row>
          <el-row>
            <!-- 开户账号 -->
            <el-col :span="12">
              
              <el-form-item label="开户账号">
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  :disabled="item.bizState=='S'" 
                  
                  @input="onInput(index,$event)"
                  @blur="checkBank(index,$event)"
                  @click.native="checkBankAccount(item,$event)"
                  v-model="item.bankAccount"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 开户行号 -->
            <el-col :span="12">
              <el-form-item label="开户行号" >
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  :disabled="item.bizState=='S'" 
                  oninput="value=value.replace(/[^\d\s]/g, '')"
                  v-model="item.bankNo"
                  placeholder="请输入"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
        </div>
        
      </div>
      <!-- end of 银行信息 -->
      <!-- start of 开票信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">开票信息</span>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <el-row style="padding: 10px 35px">
            <div class="sub-title" >
            <span>开票信息{{ index + 1 }}</span>
            <div style="display: flex">
              <div style="position: relative">
                  <el-button
                    type="defalut"
                    size="mini"
                    @click="previewInvoice(item)"
                    >预览</el-button
                  >
                  
                </div>
            
            </div>
            
          </div>
          </el-row>
          
          <el-row>
            <!-- 发票抬头-->
            <el-col :span="12">
              
              <el-form-item label="发票抬头">
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  v-model="tenantName"
                  :maxlength="50"
                  :disabled="true"
                  
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 税号 -->
            <el-col :span="12">
              <!-- 公司税号 -->
              <el-form-item label="税号">
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  v-model="formData.taxpayerId"
                  :maxlength="30"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 银行名称 -->
            <el-col :span="12">
             
             <el-form-item label="银行名称">
               <el-input
                 class="w300"
                 size="small"
                 type="text"
                 v-model="item.bankName"
                 :maxlength="50"
                 :disabled="true"
               ></el-input>
             </el-form-item>
           </el-col>
            <!-- 银行卡号 -->
            <el-col :span="12">
              
              <el-form-item label="银行账号">
                <el-input
                  class="w300"
                  size="small"
                  type="number"
                  v-model="item.bankAccount"
                  :disabled="true"
                  :maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            
            
          </el-row>
          <el-row>
            <!-- 电话号码 -->
            <el-col :span="12">
              <!-- 公司电话 -->
              <el-form-item label="电话号码" >
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  v-model="formData.tel"
                  :disabled="true"
                  :maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 单位地址-->
            <el-col :span="12">
              
              <el-form-item label="单位地址" >
                <el-input
                  class="w300"
                  size="small"
                  type="text"
                  v-model="formData.address"
                  :maxlength="100"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        
      </div>
      <!-- end of 开票信息 -->
      <!-- start of 证照信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">证照信息</span>
        <!-- start 营业执照 -->
        <el-form-item label="营业执照">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :headers="token"
                :on-exceed="handleExceedYYZZ"
                accept=".jpg,.png,.jpeg,.pdf"
                :on-remove="handlePdfRemoveYYZZ"
                :http-request="uploadPdfYYZZ"
                :file-list="fileListYYZZ"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip"> 
                    
                    {{ '最大不超过 20M 的附件，支持jpg、png、jpeg、pdf格式' }}
                  </div>
                </div>
                

              </el-upload>

              <div class="btn-box" v-if="fileListYYZZ && fileListYYZZ.length > 0">
                <a
                  :href="fileListYYZZ[0].url + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="fileListYYZZ[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(fileListYYZZ[0].url, fileListYYZZ[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(fileListYYZZ[0],'fileListYYZZ')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- end 营业执照 -->

          <!-- start 企业LOGO -->
          <el-form-item label="企业LOGO">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :headers="token"
                :on-exceed="handleExceedLOGO"
                accept=".png"
                :on-remove="handlePdfRemoveLOGO"
                :http-request="uploadPdfLOGO"
                :file-list="fileListLOGO"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">
                    
                    {{ '最大不超过 5M，底部透明的png图片，用于移动端首页' }}
                  </div>
                </div>
                
                
              </el-upload>

              <div class="btn-box" v-if="fileListLOGO && fileListLOGO.length > 0">
                <a
                  :href="fileListLOGO[0].url + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="fileListLOGO[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(fileListLOGO[0].url, fileListLOGO[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(fileListLOGO[0],'fileListLOGO')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- end 企业LOGO -->

          <!-- start 背景图 -->
          <el-form-item label="背景图">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box "
                action="#"
                :limit="1"
                :headers="token"
                :on-exceed="handleExceedBG"
                accept=".jpg,.png,.jpeg"
                :on-remove="handlePdfRemoveBG"
                :http-request="uploadPdfBG"
                :file-list="fileListBG"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip ">
                    {{ '最大不超过 5M 的图片，用于移动端“我的”背景图，支持jpg、png、jpeg格式' }}
                  </div>
                  
                </div>
                
              </el-upload>

              <div class="btn-box" v-if="fileListBG && fileListBG.length > 0">
                <a
                  :href="fileListBG[0].url + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="fileListBG[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(fileListBG[0].url, fileListBG[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(fileListBG[0],'fileListBG')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- end 背景图 -->
         
      </div>
      <!-- end of 证照信息 -->
      <!-- start of 系统对接信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">系统对接信息</span>
        <el-row>
          <!-- 系统对接方式 -->
          <el-col :span="12">
              <el-form-item label="系统对接方式" >
                <span slot="label" style="color: red"> </span>
                <span slot="label">系统对接方式 </span>
                <el-radio style="padding-right:40px" class="w300"
                  size="small" @click.native.prevent="clickitemdataType('1')" v-model="systemLinkMode" label="1">方式一：ERP系统中业务员与业务数据有绑定关系</el-radio>
                <el-radio style="padding-right:40px" class="w300"
                  size="small" @click.native.prevent="clickitemdataType('2')" v-model="systemLinkMode" label="2">方式二：ERP系统中业务员与业务数据无绑定关系</el-radio>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <!-- 数据分配时间 -->
          <el-col :span="24">
              <el-form-item label="数据分配时间">
                <span slot="label" style="color: red"> </span>
                <span slot="label">数据分配时间 </span>
                <span>在业务时间的后 
                  <el-input
                    style="width:110px"
                    size="small"
                    placeholder="天数，0~31"
                    @input="dataAllocateTime = dataAllocateTime.replace(/[^\d\-\d]/g, '')"
                    v-model.trim="dataAllocateTime"
                    maxlength="2"
                    @blur="dataAllocateTimeBlur"
                  >
                  </el-input> 天</span>
              </el-form-item>
            </el-col>
        </el-row>

          
      </div>
      <!-- end of 系统对接信息 -->
      <!-- start of 主打产品及对应病种信息 -->
      <div v-if="guid" class="back-color-fff form-box content-main-box">
        <div class="addGoods">
          <span class="form-title">主打产品及对应病种信息<el-popover trigger="hover" width="200" placement="top-start">
            <div>{{ '若该公司已存在很多历史产品信息，请至【产品资料管理】功能中维护主品信息，是否主品为【是】，是否竞品为【否】的产品才会展示在这里。' }}</div>
            <template slot="reference">
              <i class="el-icon-question"></i>
            </template>
        </el-popover></span>
          
          <el-button type="defalut" size="mini" @click="addProduct(1)" >新增</el-button >
        </div>
        <el-table :data="mainList" stripe border  style="width: 80%" v-loading="tableLoading">
          <el-table-column label="序号" header-align="center" align="center" fixed="left" width="60">
            <template slot-scope="scope">
              {{ (page1.pageIndex - 1) * page1.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="goodsName" show-overflow-tooltip label="产品名称" header-align="center" align="left" min-width="100">
            <template slot-scope="scope">{{ scope.row.goodsName || '-'}}</template>
          </el-table-column>
          <el-table-column prop="goodsSpec" show-overflow-tooltip label="产品规格" header-align="center" align="left" min-width="80">
            <template slot-scope="scope">{{ scope.row.goodsSpec || '-'}}</template>
          </el-table-column>
          <el-table-column prop="producer" show-overflow-tooltip label="生产厂家" header-align="center" align="left"  min-width="120">
            <template slot-scope="scope">{{scope.row.producer || '-'}}</template>
          </el-table-column>

          <el-table-column prop=" treatDiseasesKind" show-overflow-tooltip label="主治病种" header-align="center" align="left" min-width="150">
            <template slot-scope="scope">{{ scope.row.treatDiseasesKind || '-' }}</template>
          </el-table-column>
          
          <el-table-column prop="validityDate" label="操作" header-align="center" align="left" width="85">
            <template slot-scope="scope">
              <a
              class="txt-color"
              @click="editProduct(scope.row,1)"
              >编辑｜</a
            >
            <a class="txt-color-red" @click="delProduct(scope.row.guid,1)"
              >删除
            </a>
            </template>
          </el-table-column>
          
        </el-table>
        <div v-if="page1.totalRows>5">
          <el-pagination
            layout="prev, pager, next"
            :page-size="5"
            @current-change="handleCurrentChange1"
            :total="page1.totalRows">
          </el-pagination>
        </div>
      </div>
      <!-- end of 主打产品及对应病种信息 -->
      <!-- start of 公司竞品信息 -->
      <div  v-if="guid" class="back-color-fff form-box content-main-box">
        <div class="addGoods">
          <span class="form-title">
            公司竞品信息<el-popover trigger="hover" width="200" placement="top-start">
            <div>{{ '若该公司已存在很多历史竞品信息，请至【产品资料管理】功能中维护【主要竞品】信息，该字段为是的竞品才会展示在这里。' }}</div>
            <template slot="reference">
              <i class="el-icon-question"></i>
            </template>
        </el-popover>
          </span>
          
          <el-button type="defalut" size="mini"  @click="addProduct(2)">新增</el-button >
        </div>
        <el-table :data="competitorList" stripe border  style="width: 80%" v-loading="tableLoading">
          <el-table-column label="序号" header-align="center" align="center" fixed="left" width="60">
            <template slot-scope="scope">
              {{ (page2.pageIndex - 1) * page2.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="goodsName" show-overflow-tooltip label="产品名称" header-align="center" align="left"  min-width="100">
            <template slot-scope="scope">{{ scope.row.goodsName || '-'}}</template>
          </el-table-column>
          <el-table-column prop="goodsSpec" show-overflow-tooltip label="产品规格" header-align="center" align="left"  min-width="80">
            <template slot-scope="scope">{{ scope.row.goodsSpec || '-'}}</template>
          </el-table-column>
          <el-table-column prop="producer" show-overflow-tooltip label="生产厂家" header-align="center" align="left"   min-width="120">
            <template slot-scope="scope">{{scope.row.producer || '-'}}</template>
          </el-table-column>

          <el-table-column prop=" goodsBenchmarkName" show-overflow-tooltip label="对标自家产品名称" header-align="center" align="left" min-width="130">
            <template slot-scope="scope">{{ scope.row.goodsBenchmarkName|| '-' }}</template>
          </el-table-column>
          <el-table-column prop=" goodsBenchmarkSpec" show-overflow-tooltip label="对标自家产品规格" header-align="center" align="left" min-width="130">
            <template slot-scope="scope">{{scope.row.goodsBenchmarkSpec|| '-' }}</template>
          </el-table-column>
          
          <el-table-column prop="validityDate" label="操作" header-align="center" align="left" width="85">
            <template slot-scope="scope">
              <a
              class="txt-color"
              @click="editProduct(scope.row,2)"
              >编辑｜</a
            >
            <a class="txt-color-red" @click="delProduct(scope.row.guid,2)"
              >删除
            </a>
            </template>
          </el-table-column>
          
        </el-table>
      <div v-if="page2.totalRows>5">
          <el-pagination
            layout="prev, pager, next"
            :page-size="5"
            @current-change="handleCurrentChange2"
            :total="page2.totalRows">
          </el-pagination>
        </div>
      </div>
      <!-- end of 公司竞品信息 -->
      <!-- start of 签约合同信息 -->
      <div v-if="contractList.length>0" class="back-color-fff form-box content-main-box">
        <span class="form-title">签约合同信息</span>
        
      <el-table :data="contractList" stripe border  style="width: 90%" v-loading="tableLoading">
        <el-table-column label="序号" header-align="center" align="center" fixed="left" width="60">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="contractCode" show-overflow-tooltip label="合同编号" header-align="center" align="left" >
          <template slot-scope="scope">{{ scope.row.contractCode }}</template>
        </el-table-column>
        <el-table-column prop="contractName" show-overflow-tooltip label="合同名称" header-align="center" align="left" >
          <template slot-scope="scope">{{ scope.row.contractName }}</template>
        </el-table-column>
        <el-table-column prop="serviceTenantName" show-overflow-tooltip label="签约企业" header-align="center" align="left"  >
          <template slot-scope="scope">{{scope.row.serviceTenantName }}</template>
        </el-table-column>

        <el-table-column prop=" signDate" show-overflow-tooltip label="签约日期" header-align="center" align="left" width="130">
          <template slot-scope="scope">{{ scope.row.signDate | getDate }}</template>
        </el-table-column>
        
        <el-table-column prop="validityDate" label="合同有效期" header-align="center" align="left" width="130">
          <template slot-scope="scope">
            <span :style="{ color: getAlarmTime(scope.row.validityDate, 30) ? 'red' : '' }">
                    {{ scope.row.validityDate | getDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sendTaxDeduction" label="下发扣除税点（%）" header-align="center" align="right" width="130">
          <template slot-scope="scope">{{ scope.row.sendTaxDeduction |tax }}</template>
        </el-table-column>
        <el-table-column prop="projectManagerName" label="运营经理" header-align="center" align="left" width="120">
          <template slot-scope="scope">{{scope.row.projectManagerName|| '-' }}</template>
        </el-table-column>
      </el-table>
      </div>
      <!-- end of 签约合同信息 -->
      
      <div class="back-color-fff form-box">
        <div class="submit-btn-box submit_btn_wrap">
          <el-button type="defalut" size="small" @click="$router.go(-1)">取消</el-button>
          <el-button
            v-if="textTitle == '新增药企'"
            type="primary"
            size="small"
            @click="addReqVersion"
            v-loading.fullscreen.lock="fullscreenLoading"
            >确定</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-else
            @click="updateReqVersion"
            v-loading.fullscreen.lock="fullscreenLoading"
            >修改</el-button
          >
        </div>
      </div>
      
    </el-form>
    <!-- <el-dialog title="选择地图" :visible.sync="mapVisible" width="80%">
      <dialogMap ref="refMap" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog> -->
    <el-dialog title="地图选点" :visible.sync="mapVisible"  width="1300px">
        <dialogMap v-if="mapVisible" ref="refMap" :markers="formData.markers" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog>
    <!-- 发票信息 -->
    <InvoiceMessage :showInvoiceBox.sync="showInvoiceBox" :invoiceData="invoiceData"></InvoiceMessage>
    <!-- 指定运营经理 -->
    <ChoosePerson ref="choosePerson" staffType="1" @onSelect="getPersonSelect"></ChoosePerson>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import InvoiceMessage from '../../components/invoiceMessage.vue'
import ChoosePerson from '@/components/person/choosePerson';
import { route } from '@/api/apiRoute';
import $ from 'jquery';
import store from '@/store';
export default {
  components: {
    dialogMap,
    InvoiceMessage,
    ChoosePerson
  },
  data() {
    return {
      mapVisible:false,
      disabledInput:false,
      projectManagerGuid:'', // 运营经理
      projectManagerName:'', // 运营经理
      tenantTag:'', // 企业标签
      productRule:[],//产品规则
      taskPriceModel:'',//价格模式
      tableData1: [],//企业列表
      mainList: [],//主品列表
      competitorList: [],//竞品列表
      scrollTop:0,
      showInvoiceBox:false, // 预览发票弹框
      invoiceData:{
        invoiceHeader:'',
        taxpayerId:'',
        address_tel:'',
        bankName_acount:'',
      },

      supertubeFlagListC: [
        { value: 'Y', text: '超级管理' },
        { value: 'N', text: '普通管理' },
      ],
      
      supertubeFlagList: [{ value: 'N', text: '普通管理' }],
      supertubeFlag: '',
      // initRoleName: '数据管理员',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        enterpriseCate: null,//账号类型
        enterpriseCates: [],
        // createTime:'',//公司成立时间
      },
      // 公司主打产品
      page1: {
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        isMain:'Y',//是否主品
        isCompetitor:'N',//是否竞品
        
      },
      // 公司竞品
      page2: {
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        isCompetitor:'Y',//是否竞品
        isMain:'Y',//是否主品
      },
      // enterpriseCate: '0101',
      enterpriseCate: null,
      tenantName: '',//公司名称
      tenantNote: '',//企业简述
      // initUserName: '',//初始账号
      abbreviation: '',//公司简称
      enterpriseCate:'',//公司类型
      enterpriseCate:'',//公司类型
      memberStatus: '',// 账号类型
      dataList:{
        registerDate:'',//公司成立时间
        registerCapitalAmount:'',//注册资本
        salesScaleAmount:'',//年销售额
        isIpo:'',//是否上市
        organizationForm:'',//公司组织形式
        industryPosition:'',//行业地位
        businessScale:'',//经营规模
        businessScopeList:[],//经营范围
        mainProductCategoryList:[],//主营品种类型
        downstreamCustomer:'',//主要下游客户
        // businessType:'',//主营业务类型
        businessTypeList:[],//主营业务类型
        marketingExpenseYearPayLimit:'',//营销费用年支出额度
        marketingExpensePayObject:'',//公司营销费用支出对象
        invoiceType:'',//开票类型
        staffTypeList:[],//业务员类型
        staffVisitObjectList:[],//业务人员日常拜访对象
        juridicalPerson:'',//公司法人
        stainType:'',//司法官司
        hasItDept:'',//是否有信息部
        itAbility:'',//信息能力
        linkSystemList:[],//对接系统
        circulateType:'',//流通类型
        customerGrade:'',//客户定级
        parentTenantGuid:'',//上级企业
        accountCycle:'',//核算周期
        accountDeadline:'',//核算截止日

      },
      
      systemLinkMode: '',//系统对接方式
      dataAllocateTime: '',//数据分配时间

      fullscreenLoading: false,
      textTitle: '新增药企',
      textTitle1: '设置菜单',
      dialogVisible: false,
      dialogVisible1: false,
      guid: '',
      tenantGuid:'',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/ms-common-admin-cloud-service/obs/upload-file`,
      urlImg: `/ms-common-admin-cloud-service/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      // 证照信息
      fileListYYZZ: [], //营业执照
      fileListLOGO: [], //企业LOGO
      fileListBG: [], //背景图
      licenseGuid: '',
      formData: {
        province: null,
        city: null,
        district: null,
        contacts: null,//业务联系人
        contactTel: null,//业务联系人电话
        // venue: null,
        address:'',
        tel:'',//公司电话
        taxpayerId:'',//公司税号
        markers: '',//标注位置经纬度
        bankList: [
          {
            //银行信息
            accountType: '',//账户类型
            bankName: '',//银行名称
            bankAccount: '',//银行卡号
            bankNo: '',//开户行号
            bizState:'Y',//启用状态
            // taxpayerId:'',//税号
            // fptt:'',//发票抬头
            // dwdz:'',//单位地址
            // tel:'',//电话号码
          },
        ],
      },
      invoiceList:[{
            //开票信息
            fptt:'',//发票抬头
            taxpayerId:'',//税号
            bankName: '',//银行名称
            bankAccount: '',//银行账号
            tel:'',//电话号码
            dwdz:'',//单位地址
            
          }],
      dialogFormVisible: false,
      
      
      
      rules: {
        tenantGuid: [{ required: true, message: '请选择公司', trigger: 'blur' }],
        
      },
      dialogVisibleProvince: false,
      activeProduct: '',
      options: areaJson,
      areaData: [],
      ids: [],
      areaRangeList: [
        {
          guid: '',
          sendTenantGuid: '',
          serviceTenantGuid: '',
          areaRangeList: [],
          areaDataOptions: [],
        },
      ],
      operationRelList: [],
      tenantList: [],
      updateTenant: {
        guid: '',
        tenantGuid: '',
        sendTenantGuid: '',
        serviceTenantGuid: '',
        areaRangeList: [],
      },
      serviceTenantGuidList: [],
      
      tenantConfig: {
        tenantGuid: '',
        syncMethod: '',
        allocateDayAfter: '',
      },
      addressList: [], //地址编码
      contractList: [], //合同信息
      tenantSimpleAddDTO: {
        guid: "",
        tenantName: "",//公司名称
        abbreviation: "",//公司简称
        enterpriseCate: "",//公司类型
        memberStatus: "",// 账号类型
        taxpayerId: "",//公司税号
        province: null,
        city: null,
        district: null,
        address: "",
        tel: "",
        contacts: "",
        contactTel: "",
        pictContent: null,
        backgroundUrl: null
      },
      
    };
  },
  filters:{
    tax(val) {
      return val?val.toFixed(2) : '-';
    },
  },
  watch:{
    "dataList.accountCycle":{
      immediate:true,
      handler(val){
        if(this.dataList.accountCycle=='自然月'){
          this.dataList.accountDeadline=''
          this.disabledInput=true
        }else if(this.dataList.accountCycle=='核算月'){
          this.disabledInput=false
        }
       
      }},
    "dataList.accountDeadline":{
      immediate:true,
      handler(val){
        if(this.dataList.accountDeadline=='0'){
          this.dataList.accountDeadline=''
          
        }
      }
        
      
    }
  },
  beforeRouteEnter(to, from, next) {
    
    next();
    
  },
 // 存储数据 返回此页面时为data赋值
  beforeRouteLeave(to, from, next) {
    if (to.path=== '/addProduct') {
        let scrollH = this.scrollTop
        sessionStorage.setItem('ownScroll', scrollH)
    } else {
        sessionStorage.removeItem('ownScroll')
        this.scrollTop = 0
    }
    next()
  },
 
  created() {
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDataDetail(this.guid);
      this.getProduct(true,1)//获取主品
      this.getProduct(true,2)//获取竞品
      this.getContractData(this.guid);
    }
    this.getSelectData();//获取上级企业
    if (sessionStorage.getItem('ownScroll')) {
        this.scrollTop = sessionStorage.getItem('ownScroll')
        this.positScroll(this.scrollTop)
    }
  },
  mounted() {
    $('.el-main').scroll((e) => {
      // debugger
      let scrollTop = e.target.scrollTop;
      this.scrollTop=scrollTop
      
    });
  },
  methods: {
    //监听窗口滚动
    windowScrollListener(scrollTop) {
      //获取操作元素最顶端到页面顶端的垂直距离
      if (this.searchShow) {
        if (scrollTop >= 195) {
          this.isVisable = true; 
        }
        if (scrollTop < 195) {
          this.isVisable = false; 
        }
      } else {
        if (scrollTop >= 165) {
          this.isVisable = true; 
        }
        if (scrollTop < 165) {
          this.isVisable = false;
        }
      }
    },
    positScroll(scrollTop){
        this.$nextTick(() => {
            let main = document.getElementById('el-main-upstream-settlement-management')
            main.scrollTop = scrollTop
        })
    },
    // 校验银行账号
    checkBank(idx,event){
      this.$set(this.formData.bankList[idx],'bankAccount',event.target.value)
      let arr=this.formData.bankList.filter(item=>{
        return item.bankAccount==event.target.value
      })
      console.log('arr',arr);
      if(arr.length>1){
        this.$message.error('相同的银行卡号不允许重复添加')
        this.$set(this.formData.bankList[idx],'bankAccount','')
      }
      
    },
    // 开户账号校验
    onInput(idx,event) { 
      const newValue = event; 
      const numericValue = newValue.replace(/\D/g, ''); // 仅保留数字 
      // 检查输入是否包含非数字字符 
      if (newValue !== numericValue) { 
        // 如果有非数字字符，则更新输入框的值为仅包含数字的值
        this.$set(this.formData.bankList[idx],'bankAccount',numericValue)
        //  this.inputValue = numericValue; 
        } else { 
          // 如果输入内容只包含数字，则保持输入框的当前值不变 
          this.$set(this.formData.bankList[idx],'bankAccount',newValue)
          // this.inputValue = newValue; 
        } 
    },
    getDataDetail(guid) {
      let self = this;
      this.guid = guid;
      // /tenant/data/get-tenant-detail
      // /tenant-expand/get-medicine-enterprise-detail
      // /tenant-expand/get-medicine-enterprise-detail
      self.api.get('/ms-customer-service/tenant-expand/get-medicine-enterprise-detail?tenantGuid=' + this.guid).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let detail = res.data.data;
          let tenantInfo = detail.tenantSimpleAddDTO;
          let marker = {
              lat: detail.lat,
              lng: detail.lng,
            };
          this.tenantGuid=detail.tenantGuid
          this.guid=detail.guid ||""
          this.textTitle = '编辑药企';

          this.tenantName = tenantInfo.tenantName;//公司名称
          this.abbreviation = tenantInfo.abbreviation;//公司简称

          this.tenantTag = detail.tenantTag;//
          this.taskPriceModel = detail.taskPriceModel
          this.productRule = detail.productRule?detail.productRule:[];//产品规则
          this.projectManagerGuid = detail.projectManagerGuid;//运营经理
          this.projectManagerName = detail.projectManagerName;//运营经理
          
          this.enterpriseCate= tenantInfo.enterpriseCate,//公司类型
          this.memberStatus= tenantInfo.memberStatus,// 账号类型
          this.formData = {
            province: tenantInfo.province,
            city: tenantInfo.city,
            district: tenantInfo.district,
            contacts: tenantInfo.contacts,
            contactTel: tenantInfo.contactTel,
            // venue: tenantInfo.venue,
            address: tenantInfo.address,
            tel: tenantInfo.tel,
            markers:marker,
            taxpayerId:tenantInfo.taxpayerId,
          };
          this.dataList={
            registerDate:detail.registerDate,//公司成立时间
            registerCapitalAmount:detail.registerCapitalAmount,//注册资本
            salesScaleAmount:detail.salesScaleAmount,//年销售额
            isIpo:detail.isIpo,//是否上市
            organizationForm:detail.organizationForm,//公司组织形式
            industryPosition:detail.industryPosition,//行业地位
            businessScale:detail.businessScale,//经营规模
            businessScopeList:detail.businessScopeList,//经营范围
            mainProductCategoryList:detail.mainProductCategoryList,//主营品种类型
            downstreamCustomer:detail.downstreamCustomer,//主要下游客户
            businessTypeList:detail.businessTypeList,//主营业务类型
            marketingExpenseYearPayLimit:detail.marketingExpenseYearPayLimit,//营销费用年支出额度
            marketingExpensePayObject:detail.marketingExpensePayObject,//公司营销费用支出对象
            invoiceType:detail.invoiceType,//开票类型
            staffTypeList:detail.staffTypeList,//业务员类型
            staffVisitObjectList:detail.staffVisitObjectList,//业务人员日常拜访对象
            juridicalPerson:detail.juridicalPerson,//公司法人
            stainType:detail.stainType,//司法官司
            hasItDept:detail.hasItDept,//是否有信息部
            itAbility:detail.itAbility,//信息能力
            linkSystemList:detail.linkSystemList,//对接系统
            circulateType:detail.circulateType,//流通类型
            customerGrade:detail.customerGrade,//客户定级
            parentTenantGuid:detail.parentTenantGuid,//上级企业
            // 核算周期字段默认为“核算截止日”，自然月的截止日为0，核算月不为0
            // accountCycle:detail.accountCycle,//核算周期
            // accountCycle:detail.accountDeadline=='0'?'自然月':'核算月',//核算周期
            // 自然月的截止日为0，页面不展示
            // accountDeadline:detail.accountDeadline=='0'?'':detail.accountDeadline,//核算截止日
            
          }
          if(detail.accountDeadline){
            // this.dataList.accountCycle=detail.accountDeadline=='0'?'自然月':'核算月'
            // this.dataList.accountDeadline=detail.accountDeadline=='0'?'':detail.accountDeadline
            if(detail.accountDeadline=='0'){
              this.$set(this.dataList,'accountCycle','自然月')
              this.$set(this.dataList,'accountDeadline','')
            }else{
              this.$set(this.dataList,'accountCycle','核算月')
              this.$set(this.dataList,'accountDeadline',detail.accountDeadline)
            }
            
            
          }else{
            this.$set(this.dataList,'accountCycle','')
            this.$set(this.dataList,'accountDeadline','')
            
          }
          this.systemLinkMode=detail.systemLinkMode,//系统对接方式
          this.dataAllocateTime=detail.dataAllocateTime,//数据分配时间
          
          console.log(111,self.formData.markers);
          this.addressList= [tenantInfo.province, tenantInfo.city, tenantInfo.district]
          //银行信息
          if (detail.bankList && detail.bankList.length) {
            // this.formData['bankList'] = detail.bankList;
            this.$set(this.formData, 'bankList', detail.bankList);
          } else {
            this.$set(this.formData, 'bankList', [
              {
                //银行信息
                accountType: '',//账户类型
                bankName: '',//银行名称
                bankAccount: '',//银行卡号
                bankNo: '',//开户行号
                // taxpayerId:'',//税号
                // fptt:'',//发票抬头
                // dwdz:'',//单位地址
                // tel:'',//电话号码
              },
            ]);
          }

          if (!tenantInfo.province) {
            this.addressList = [];
          } else {
            this.addressList = [tenantInfo.province, tenantInfo.city, tenantInfo.district];
          }

          if (tenantInfo.pictContent) {
            this.fileListLOGO = [];
            let pictContent = JSON.parse(tenantInfo.pictContent);
            pictContent.forEach((item) => {
              this.fileListLOGO.push({
                name: item.name,
                url: item.url,
              });
            });
          } else {
            this.fileListLOGO = [];
          }
          if (tenantInfo.backgroundUrl) {
            this.fileListBG = [];
            let backgroundUrl = JSON.parse(tenantInfo.backgroundUrl);
            backgroundUrl.forEach((item) => {
              this.fileListBG.push({
                name: item.name,
                url: item.url,
              });
            });
          } else {
            this.fileListBG = [];
          }
          if (detail.tenantLicVOs && detail.tenantLicVOs.length != 0) {
            this.fileListYYZZ = [];
            let tenantLicVOs = JSON.parse(detail.tenantLicVOs[0].pictContent);
            tenantLicVOs.forEach((item) => {
              this.fileListYYZZ.push({
                name: item.name,
                url: item.url,
              });
              this.licenseGuid = detail.tenantLicVOs[0].guid;
            });
          } else {
            this.fileListYYZZ = [];
            this.licenseGuid = '';
          }
          if (detail.tenantConfig) {
            this.tenantConfig = detail.tenantConfig;
          } else {
            this.tenantConfig = {
              tenantGuid: '',
              syncMethod: '',
              allocateDayAfter: '',
            };
          }
          
          this.dialogVisible = true;
        } else {
          self.$message.error(res.data.msg);
        }
      });

      this.$forceUpdate();
    },
    // 获取产品列表
    getProduct(flg,tab) {
      // tab=1获取主品
      // tab=2获取竞品
      let self = this;
      self.loading = true;
      let req={}
      if(tab===1){
        req=self.page1
      }else if(tab===2){
        req=self.page2
      }
      req.tenantGuid=self.$route.query.guid
      if (flg) {
        req.pageIndex = 1;
      }
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          let list=res.data.data.records
          // isMain:'Y',//是否主品
        // isCompetitor:'N',//是否竞品
          if(tab===1){
            
            self.mainList=list;
            self.page1.totalPage = res.data.data.totalPages;
            self.page1.totalRows = res.data.data.totalRows;
          }else if(tab===2){
            self.competitorList=list;
            self.page2.totalPage = res.data.data.totalPages;
            self.page2.totalRows = res.data.data.totalRows;
          }
          // let productInformationList = res.data.data.records;
          // self.page.totalPage = res.data.data.totalPages;
          // self.page.totalRows = res.data.data.totalRows;
          // self.productInformationList = productInformationList;
          
        } else {
          self.$message.error(res.msg || '服务异常');
          console.log(res);
          self.loading = false;
        }
      });
    },
    addProduct(flg) {
      let guid=this.$route.query.guid
      // flg为1主品，是否竞品=N是否主品=Y，公司名称不可编辑
      // flg为2竞品，是否竞品=Y主要竞品=Y，公司名称不可编辑
      this.$router.push(`/addProduct?tenantGuid=${guid}&isMain=${flg}&productGuid=${this.$route.query.productGuid}`);
    },
    editProduct(row,flg) {
      this.$router.push(`/addProduct?guid=${row.guid}&isMain=${flg}&productGuid=${this.$route.query.productGuid}`);
    },
    delProduct(guid,flg) {
      let self = this;
      self
        .$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msProductService}/goods/data/delete`, [guid])
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除产品成功');
                self.getProduct(true,flg);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleCurrentChange1(val){
      let self = this;
      self.page1.pageIndex = val
      this.getProduct(false,1);
    },
    handleCurrentChange2(val){
      let self = this;
      self.page2.pageIndex = val
      this.getProduct(false,2);
    },
    incres() {
      
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes();
      let arr = checkedNodes[0].pathNodes;
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      this.formData.province = codeArr[0];
      this.formData.city = codeArr[1];
      this.formData.district = codeArr[2];
      let venue = '';
      if (codeArr) {
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      // this.formData.venue = venue;
      console.log('venue',this.formData);
      
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    handleExceedBG(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleExceedLOGO(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleExceedYYZZ(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handlePdfRemoveBG(file) {
      let self = this;
      self.fileListBG.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileListBG.splice(ind, 1);
        }
      });
    },
    handlePdfRemoveLOGO(file) {
      let self = this;
      self.fileListLOGO.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileListLOGO.splice(ind, 1);
        }
      });
    },
    handlePdfRemoveYYZZ(file) {
      let self = this;
      self.fileListYYZZ.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileListYYZZ.splice(ind, 1);
        }
      });
    },
    uploadPdfBG(file) {
      let self = this;
      let is5M = file.file.size / 1024 / 1024 < 5; // 限制小于5M
      // console.log(file.file.size,is5M);
      if (!is5M) {
        this.fileListBG.splice(this.fileListYYZZ.length, 1);
        self.$message.error('大小不可超过5MB');
        return;
      }
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '背景',
              url: res.data.data,
            };
            self.fileListBG.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadPdfLOGO(file) {
      let self = this;
      let is5M = file.file.size / 1024 / 1024 < 5; // 限制小于5M
      // console.log(file.file.size,is5M);
      if (!is5M) {
        this.fileListLOGO.splice(this.fileListYYZZ.length, 1);
        self.$message.error('大小不可超过5MB');
        return;
      }
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '企业LOGO',
              url: res.data.data,
            };
            self.fileListLOGO.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadPdfYYZZ(file) {
      let self = this;
      let is5M = file.file.size / 1024 / 1024 < 20; // 限制小于5M
      // console.log(file.file.size,is5M);
      if (!is5M) {
        this.fileListYYZZ.splice(this.fileListYYZZ.length, 1); //营业执照
        self.$message.error('大小不可超过20MB');
        return;
      }
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '营业执照',
              url: res.data.data,
            };
            self.fileListYYZZ.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    // 添加
    addReqVersion() {
      // 基础必填
      if (!this.tenantName) {
        this.$message.error('请填写公司名称');
        return;
      }
      if (!this.abbreviation) {
        this.$message.error('请填写公司简称');
        return;
      }
      if (!this.enterpriseCate) {
        this.$message.error('请填写公司类型');
        return;
      }
      if (!this.memberStatus) {
        this.$message.error('请选择账号类型');
        return;
      }
      //如果核算周期是核算月，那截止日必填
      if(this.dataList.accountCycle=="核算月"){
        if (!this.dataList.accountDeadline) {
          this.$message.error('请填写核算截止日');
          return;
        }
      }else if(this.dataList.accountCycle=="自然月"){
        // 核算周期是自然月，截止日为0
        this.dataList.accountDeadline='0'
      }
      // 联系方式必填
      if (!this.formData.contacts) {
        this.$message.error('请填写业务联系人');
        return;
      }
      if (!this.formData.contactTel) {
        this.$message.error('请填写业务联系人电话');
        return;
      }
      if (!this.formData.tel) {
        this.$message.error('请填写公司电话');
        return;
      }
      if (!this.formData.markers) {
        this.$message.error('请选择标注位置');
        return;
      }
      if (!this.formData.address) {
        this.$message.error('请填写详细地址');
        return;
      }

      if (!this.tenantTag) {
        this.$message.error('请填写企业标签');
        return;
      }
      if (!this.taskPriceModel) {
        this.$message.error('指选择价格模式');
        return;
      }
      if (!this.projectManagerGuid) {
        this.$message.error('指定运营经理');
        return;
      }
      // 公司的纳税人税号
      // if (!this.formData.taxpayerId) {
      //   this.$message.error('请填写税号');
      //   return;
      // }
      // 银行信息必填
      if (this.formData.bankList.length > 0) {
        this.formData.bankList.forEach((item,idx)=>{
          if(!item.accountType && !item.bankName && !item.bankAccount && !item.bankNo ){
            this.formData.bankList.splice(idx,1);
          }
        })
       
        
        // try {
        //   this.formData.bankList.forEach((item,idx) => {
        //     console.log('item.bankAccount',item.bankAccount);
        //     if (!item.accountType) {
        //       throw new Error('账户类型不能为空');
        //     }
        //     if (!item.bankName) {
        //       throw new Error('银行名称不能为空');
        //     }
        //     if (!item.bankAccount) {
        //       throw new Error('银行卡号不能为空');
        //     }
        //     // if (!item.taxpayerId) {
        //     //   throw new Error('税号不能为空');
        //     // }
        //     // 银行信息未修改
        //     // if (!item.fptt) {
        //     //   throw new Error('发票抬头不能为空');
        //     // }
        //     // if (!item.dwdz) {
        //     //   throw new Error('单位地址不能为空');
        //     // }
        //     // if (!item.tel) {
        //     //   throw new Error('电话号码不能为空');
        //     // }
        //   });
        // } catch (e) {
        //   this.$message.error(e.message);
        //   return;
        // }
      }
      // if(this.enterpriseCate=='010201'){
      //   if(!this.tenantConfig.syncMethod){
      //     this.$message.error('请选择系统对接方式');
      //   }
      // }
     
      var self = this;
      var req = {
        // tenantNote: self.tenantNote,//企业简述
        tenantName: self.tenantName,//公司名称
        abbreviation: self.abbreviation,//公司简称
        enterpriseCate: self.enterpriseCate,//公司类型
        tenantTag: this.tenantTag, // 企业标签
        taskPriceModel: this.taskPriceModel,
        productRule: this.productRule.length>0?this.productRule:null, // 产品规则
        projectManagerGuid: this.projectManagerGuid, // 运营经理
        projectManagerName: this.projectManagerName, // 运营经理
        // initUserName: this.initUserName,//初始账号
        // initRoleName: this.initRoleName,
        memberStatus: self.memberStatus,// 账号类型
        //datalist
        registerDate:self.dataList.registerDate,//公司成立时间
        registerCapitalAmount:self.dataList.registerCapitalAmount,//注册资本
        salesScaleAmount:self.dataList.salesScaleAmount,//年销售额
        isIpo:self.dataList.isIpo,//是否上市
        organizationForm:self.dataList.organizationForm,//公司组织形式
        industryPosition:self.dataList.industryPosition,//行业地位
        businessScale:self.dataList.businessScale,//经营规模
        businessScopeList:self.dataList.businessScopeList,//经营范围
        mainProductCategoryList:self.dataList.mainProductCategoryList,//主营品种类型
        downstreamCustomer:self.dataList.downstreamCustomer,//主要下游客户
        businessTypeList:self.dataList.businessTypeList,//主营业务类型
        marketingExpenseYearPayLimit:self.dataList.marketingExpenseYearPayLimit,//营销费用年支出额度
        marketingExpensePayObject:self.dataList.marketingExpensePayObject,//公司营销费用支出对象
        invoiceType:self.dataList.invoiceType,//开票类型
        staffTypeList:self.dataList.staffTypeList,//业务员类型
        staffVisitObjectList:self.dataList.staffVisitObjectList,//业务人员日常拜访对象
        juridicalPerson:self.dataList.juridicalPerson,//公司法人
        stainType:self.dataList.stainType,//司法官司
        hasItDept:self.dataList.hasItDept,//是否有信息部
        itAbility:self.dataList.itAbility,//信息能力
        linkSystemList:self.dataList.linkSystemList,//对接系统
        circulateType:self.dataList.circulateType,//流通类型
        customerGrade:self.dataList.customerGrade,//客户定级
        parentTenantGuid:self.dataList.parentTenantGuid,//上级企业
        // accountCycle:self.dataList.accountCycle,//核算周期
        accountCycle:'核算截止日',//核算周期
        accountDeadline:self.dataList.accountDeadline,//核算截止日
        systemLinkMode:self.systemLinkMode,//系统对接方式
        dataAllocateTime:self.dataAllocateTime,//数据分配时间
      // --------------------------
      tenantSimpleAddDTO: {
        tenantName: self.tenantName,//公司名称
        abbreviation: self.abbreviation,//公司简称
        enterpriseCate: self.enterpriseCate,//公司类型
        memberStatus: self.memberStatus,// 账号类型
        taxpayerId: self.formData.taxpayerId,//公司税号
        province: self.formData.province,
        city: self.formData.city,
        district: self.formData.district,
        // venue: self.formData.venue,
        address: self.formData.address,
        tel: self.formData.tel,
        contacts: self.formData.contacts,
        contactTel: self.formData.contactTel,
        pictContent: this.fileListLOGO.length != 0 ? JSON.stringify(this.fileListLOGO) : null,//企业图标
        backgroundUrl:this.fileListBG.length != 0 ? JSON.stringify(this.fileListBG) : null,//企业背景图
      },
      // --------------------------
        // supertubeFlag: this.supertubeFlag,
        // appSideGuid: '',
        // backgroundUrl: this.fileListBG.length != 0 ? JSON.stringify(this.fileListBG) : null,//企业背景图
        // pictContent: this.fileListLOGO.length != 0 ? JSON.stringify(this.fileListLOGO) : null,//企业图标
        // platformGuid: '',
        // memberStatus: this.memberStatus,
        // tenantConfig: this.enterpriseCate == '010201' ? this.tenantConfig : null,
        // ========== 
        // province: self.formData.province,
        // city: self.formData.city,
        // district: self.formData.district,
        // address: self.formData.address,
        // contacts: self.formData.contacts,//业务联系人
        // contactTel: self.formData.contactTel,//业务联系人电话
        // venue: self.formData.venue,
        // taxpayerId: self.formData.taxpayerId,//公司税号
        // tel: self.formData.tel,//公司电话
        lng: self.formData.markers.lng,
        lat: self.formData.markers.lat,
        
        bankList: self.formData.bankList,
        
      };
      // 营业执照
      if (this.fileListYYZZ.length != 0) {
        req.tenantLicAddDTOs = [
          {
            licenseNum: '0000',
            licenseType: '1',
            pictContent: JSON.stringify(this.fileListYYZZ),
            isUnlimited: 'N',
            beginDate: '',
            endDate: '',
            guid: '',
          },
        ];
      }
      req.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
      if (location.href.indexOf('https://scm-operation.csyaoly.com/') > -1) {
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      } else {
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      }
      self.fullscreenLoading = true;
      // /tenant/data/add
      // /tenant-expand/add-medicine-enterprise
      return new Promise((resolve,reject)=>{
        self.api.postJson(`/ms-customer-service/tenant-expand/add-medicine-enterprise`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('新增成功');
            self.$router.go(-1); // 返回上一页
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
    },
    // 编辑
    updateReqVersion() {
      // 基础必填
      if (!this.tenantName) {
        this.$message.error('请填写公司名称');
        return;
      }
      if (!this.abbreviation) {
        this.$message.error('请填写公司简称');
        return;
      }
      if (!this.enterpriseCate) {
        this.$message.error('请填写公司类型');
        return;
      }
      if (!this.memberStatus) {
        this.$message.error('请选择账号类型');
        return;
      }
      //如果核算周期是核算月，那截止日必填
      if(this.dataList.accountCycle=="核算月"){
        if (!this.dataList.accountDeadline) {
          this.$message.error('请填写核算截止日');
          return;
        }
      }else if(this.dataList.accountCycle=="自然月"){
        // 核算周期是自然月，截止日为0
        this.dataList.accountDeadline='0'
      }
      // 联系方式必填
      if (!this.formData.contacts) {
        this.$message.error('请填写业务联系人');
        return;
      }
      if (!this.formData.contactTel) {
        this.$message.error('请填写业务联系人电话');
        return;
      }
      if (!this.formData.tel) {
        this.$message.error('请填写公司电话');
        return;
      }
      if (!this.formData.markers) {
        this.$message.error('请选择标注位置');
        return;
      }
      if (!this.formData.address) {
        this.$message.error('请填写详细地址');
        return;
      }

      if (!this.tenantTag) {
        this.$message.error('请填写企业标签');
        return;
      }
      if (!this.taskPriceModel) {
        this.$message.error('请选择价格模式');
        return;
      }
      if (!this.projectManagerGuid) {
        this.$message.error('指定运营经理');
        return;
      }

      
      
      // 公司的纳税人税号
      // if (!this.formData.taxpayerId) {
      //   this.$message.error('请填写税号');
      //   return;
      // }
      // 银行信息必填
      if (this.formData.bankList.length > 0) {
        console.log('8',this.formData.bankList);
        for (let i = 0; i< this.formData.bankList.length; i++) {
          let item=this.formData.bankList[i]
          if(!item.accountType && !item.bankName && !item.bankAccount && !item.bankNo ){
            this.formData.bankList.splice(i,1)
            i--
          }
        
        }
        // this.formData.bankList.forEach((item,idx)=>{
        //   if(!item.accountType && !item.bankName && !item.bankAccount && !item.bankNo ){
        //     console.log('o',idx);
        //     list.push(idx)
        //     // this.formData.bankList.splice(idx,1);
        //   }
        // })
        console.log('p',this.formData.bankList);
      
        // try {
        //   this.formData.bankList.forEach((item) => {
        //     if (!item.accountType) {
        //       throw new Error('账户类型不能为空');
        //     }
        //     if (!item.bankName) {
        //       throw new Error('银行名称不能为空');
        //     }
        //     if (!item.bankAccount) {
        //       throw new Error('银行卡号不能为空');
        //     }
        //     // if (!item.taxpayerId) {
        //     //   throw new Error('税号不能为空');
        //     // }
        //     // 银行信息未修改
        //     // if (!item.fptt) {
        //     //   throw new Error('发票抬头不能为空');
        //     // }
        //     // if (!item.dwdz) {
        //     //   throw new Error('单位地址不能为空');
        //     // }
        //     // if (!item.tel) {
        //     //   throw new Error('电话号码不能为空');
        //     // }
        //   });
        // } catch (e) {
        //   this.$message.error(e.message);
        //   return;
        // }
      }
      
      // if(this.enterpriseCate=='010201'){
      //   if(!this.tenantConfig.syncMethod){
      //     this.$message.error('请选择系统对接方式');
      //   }
      // }
      var self = this;
      var req = {
        guid: this.guid,
        tenantGuid: this.tenantGuid,
        tenantTag: this.tenantTag, // 企业标签
        taskPriceModel:this.taskPriceModel,
        productRule: this.productRule.length>0?this.productRule:null, // 企业标签
        projectManagerGuid: this.projectManagerGuid, // 运营经理
        projectManagerName: this.projectManagerName, // 运营经理
        // tenantNote: this.tenantNote,
        // enterpriseCate: this.enterpriseCate,
        // initUserName: this.initUserName,
        abbreviation: this.abbreviation,
        companyType: this.companyType,
        memberStatus: this.memberStatus,
        //datalist
        registerDate:self.dataList.registerDate,//公司成立时间
        registerCapitalAmount:self.dataList.registerCapitalAmount,//注册资本
        salesScaleAmount:self.dataList.salesScaleAmount,//年销售额
        isIpo:self.dataList.isIpo,//是否上市
        organizationForm:self.dataList.organizationForm,//公司组织形式
        industryPosition:self.dataList.industryPosition,//行业地位
        businessScale:self.dataList.businessScale,//经营规模
        businessScopeList:self.dataList.businessScopeList,//经营范围
        mainProductCategoryList:self.dataList.mainProductCategoryList,//主营品种类型
        downstreamCustomer:self.dataList.downstreamCustomer,//主要下游客户
        businessTypeList:self.dataList.businessTypeList,//主营业务类型
        marketingExpenseYearPayLimit:self.dataList.marketingExpenseYearPayLimit,//营销费用年支出额度
        marketingExpensePayObject:self.dataList.marketingExpensePayObject,//公司营销费用支出对象
        invoiceType:self.dataList.invoiceType,//开票类型
        staffTypeList:self.dataList.staffTypeList,//业务员类型
        staffVisitObjectList:self.dataList.staffVisitObjectList,//业务人员日常拜访对象
        juridicalPerson:self.dataList.juridicalPerson,//公司法人
        stainType:self.dataList.stainType,//司法官司
        hasItDept:self.dataList.hasItDept,//是否有信息部
        itAbility:self.dataList.itAbility,//信息能力
        linkSystemList:self.dataList.linkSystemList,//对接系统
        circulateType:self.dataList.circulateType,//流通类型
        customerGrade:self.dataList.customerGrade,//客户定级
        parentTenantGuid:self.dataList.parentTenantGuid,//上级企业
        // accountCycle:self.dataList.accountCycle,//核算周期
        accountCycle:"核算截止日",//核算周期
        accountDeadline:self.dataList.accountDeadline,//核算截止日
        systemLinkMode:self.systemLinkMode,//系统对接方式
        dataAllocateTime:self.dataAllocateTime,//数据分配时间
      // --------------------------
      tenantSimpleUpdateDTO: {
        guid: this.tenantGuid,
        tenantName: self.tenantName,//公司名称
        abbreviation: self.abbreviation,//公司简称
        enterpriseCate: self.enterpriseCate,//公司类型
        memberStatus: self.memberStatus,// 账号类型
        taxpayerId: self.formData.taxpayerId,//公司税号
        province: self.formData.province,
        city: self.formData.city,
        district: self.formData.district,
        // venue: self.formData.venue,
        address: self.formData.address,
        tel: self.formData.tel,
        contacts: self.formData.contacts,
        contactTel: self.formData.contactTel,
        pictContent: this.fileListLOGO.length != 0 ? JSON.stringify(this.fileListLOGO) : null,//企业图标
        backgroundUrl:this.fileListBG.length != 0 ? JSON.stringify(this.fileListBG) : null,//企业背景图
      },
      // --------------------------
        // initRoleName: this.initRoleName,
        // supertubeFlag: this.supertubeFlag,
        appSideGuid: '',
        backgroundUrl: this.fileListBG.length != 0 ? JSON.stringify(this.fileListBG) : null,//企业背景图
        pictContent: this.fileListLOGO.length != 0 ? JSON.stringify(this.fileListLOGO) : null,//企业图标
        appSideGuid: '',
        platformGuid: '',
        
        // tenantConfig: this.enterpriseCate == '010201' ? this.tenantConfig : null, //系统对接方式
        province: self.formData.province,
        city: self.formData.city,
        district: self.formData.district,
        address: self.formData.address,
        contacts: self.formData.contacts,
        contactTel: self.formData.contactTel,
        // venue: self.formData.venue,
        taxpayerId: self.formData.taxpayerId,//公司税号
        tel: self.formData.tel,
        lng: self.formData.markers.lng,
        lat: self.formData.markers.lat,
        bankList: self.formData.bankList,
      };
      if (this.fileListYYZZ.length != 0) {
        req.tenantLicUpdateDTOs = [
          {
            licenseNum: '0000',
            licenseType: '1',
            pictContent: JSON.stringify(this.fileListYYZZ),
            isUnlimited: 'N',
            beginDate: '',
            endDate: '',
            guid: this.licenseGuid,
          },
        ];
      } else {
        req.tenantLicUpdateDTOs = null;
      }
      req.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
      if (location.href.indexOf('https://scm-operation.csyaoly.com/') > -1) {
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      } else {
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      }
      self.fullscreenLoading = true;
      // /tenant-expand/update-medicine-enterprise
      // /tenant/data/update
      return new Promise((resolve,reject)=>{
        self.api.put(`/ms-customer-service/tenant-expand/update-medicine-enterprise`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功');
            self.$router.go(-1); // 返回上一页
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
    },
    /**
     * 查看文件
     * @param {*} url
     * @param {*} name 图片名称
     */
    seeDetail(url, name) {
      var fileSuffix = name ? name.substring(name.lastIndexOf('.') + 1) : '';
      return window.open(url, name);
    },
    /**
     * 删除文件
     * @param {*} url
     * @param {*} name 图片名称
     */
    handleMainRemove(file,key) {
      
          this[key].splice(0, 1);
        
    },
    //新增银行
    addBankItem() {
      try {
        this.formData.bankList.forEach((item,idx) => {
          // console.log('item.bankAccount',item.bankAccount);
          if (!item.accountType && !item.bankName && !item.bankAccount && !item.bankNo) {
            throw new Error('请填写开户行信息后再新增');
          }
          
        });
      } catch (e) {
        this.$message.warning(e.message);
        return;
      }
      this.formData['bankList'].push({
        accountType: null,
        bankName: null,
        bankAccount: null,
        bankNo: null,//开户行号
        bizState:'Y'
      });
    },
    //删除银行
    delBankItem(item,index) {
      var self = this;
      let enterpriseCate=self.enterpriseCate
      self.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if(item.guid){
          self.tableLoading = true;
          // tenant/data/delete
          self.api.postJson(`/ms-customer-service/tenant-expand/tenant-bank/delete?enterpriseCate=${enterpriseCate}&guid=${item.guid}`).then((res) => {
            self.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.formData['bankList'].splice(index, 1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        }else{
          this.formData['bankList'].splice(index, 1);
        }
          
        
      });
      
    },
    // 银行信息启用/停用
    enableBankItem(item, type) {
      let self=this
      
      let req={
        bizState:type,
        guid:item.guid
      }
      self.fullscreenLoading = true;
      self.api.put(`/ms-customer-service/tenant-expand/tenant-bank/update-state?bizState=${type}&guid=${item.guid}`).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('修改成功');
          item.bizState=type
        } else {
          self.$message.error(res.data.msg);
        }
      });
      if (item.guid) {
        item.enable = type;
      } else {
        this.$message.error(`银行信息不存在`);
      }
    },
    //电话校验
    checkPhone(value,flag,index) {
      let regExp = null;
      // 联系方式业务员电话
      if(flag==1){
        // regExp=/^(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57]|19[89])[0-9]{8}$/g;
        regExp=/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
        
      }
      // 联系方式公司电话
      if(flag==2){
        regExp=/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      }
      // 银行信息公司电话
      if(flag==3){
        regExp=/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      }
      let { formData } = this;
      if (regExp.test(value)) {
        if(flag==1)formData.contactTel=value;
        if(flag==2)formData.tel = value;
        if(flag==3)formData.bankList[index].tel = value;
      } else {
        this.$message.warning('请输入正确的电话')
        if(flag==1)formData.contactTel = '';
        if(flag==2)formData.tel = '';
        if(flag==3)formData.bankList[index].tel = '';
      }
    },
    // 银行卡校验提醒
    checkBankAccount(item,$event) {
      if (item.bankAccount && item.guid) {
        this.api.get(`/${serverConfig.msCustomerService}/tenant-expand/tenant-bank/is-update?guid=${item.guid}&enterpriseCate=${this.enterpriseCate}`).then((res) => {
          if (res.data.code === '0000') {
              if (res.data.msg) {
                this.$confirm(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {});
              }
            }
        });
      }
    },
    showMap() {
      this.mapVisible= true;
    },
    getMarkers(marker) {
      this.mapVisible = false;
      this.formData.markers = marker;
      this.addressList = [marker.province,marker.city,marker.district];
      this.formData.address = marker.address;
      this.formData.province = marker.province;
      this.formData.city = marker.city;
      this.formData.district = marker.district;
      this.province(this.formData.province);
      this.city(this.formData.city);
      // this.formData.venue = this.province(marker.province) + '/' + this.city(marker.city) + '/' + this.district(marker.district);
      
      // marker.province+ '/'+ marker.city+ '/'+marker.district;
      console.log('markermarker', marker);
    },
    close() {
      this.mapVisible = false;
    },
    // 获取企业列表
    getSelectData() {
      let self = this; 
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      // /tenant/data/get-tenant-operation
      // /tenant-expand/get-medicine-enterprise-list
      // let param = {'pageIndex':1,'pageSize':-1,'bizState':'Y','enterpriseCates':this.$getValueListByKey('上游客户分类')}
      let tenantGuid=this.guid
      let url=this.guid?`/${serverConfig.msCustomerService}/tenant-expand/get-medicine-enterprise-list?tenantGuid=${tenantGuid}`:`/${serverConfig.msCustomerService}/tenant-expand/get-medicine-enterprise-list`
      self.api.get(url).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData1 = res.data.data   
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    
    // 获取合同信息
    getContractData(guid) {
      this.api
        .postJson(`/${serverConfig.msCustomerService}/contract/detail-by-tenant-new`, {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: guid, // 甲方企业GUID
          approveState: 'Y', // U不审批 N审批初始状态 Y已通过 R驳回 C撤销
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            this.contractList = res.data.data || [];
            // if (fn) fn();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     *
     * 判断是否在某个时间点内
     * date 输入日期(new Date())
     * dayNum 天数
     */
     getAlarmTime(date, dayNum) {
      let flag = false;
      let contractTime = new Date(date).getTime();
      let currentTime = new Date().getTime();
      let alarmTime = dayNum * 1000 * 24 * 60 * 60;
      if (contractTime - currentTime <= alarmTime) {
        flag = true;
      } else {
        flag = false;
      }
      return flag
    },
    //核算截止日
    accountDeadlineBlur(){
      
      if (this.dataList.accountDeadline<1||this.dataList.accountDeadline>31) {
        this.$message.error('核算截止日范围为1~31');
        this.dataList.accountDeadline=''
        return;
      }else if(this.dataList.accountDeadline[0]=='0'){
          
        this.$message.error('核算截止日不能以0开头');
        this.dataList.accountDeadline=''
        return;
      }
    },
    //数据分配时间
    dataAllocateTimeBlur(){
      if (this.dataAllocateTime<0||this.dataAllocateTime>31) {
        this.dataAllocateTime=''
        this.$message.error('数据分配时间范围为0~31');
        return;
      }
    },
    blurName(value,flg) {
      if(flg===1){
        this.dataList.juridicalPerson = this.$NameCheckBlur(this, value);
      }
      if(flg===2){
        this.formData.contacts = this.$NameCheckBlur(this, value);
      }
      
    },
    // 预览发票
    previewInvoice(item) {
      this.showInvoiceBox = true
      this.invoiceData.invoiceHeader = this.tenantName
      this.invoiceData.taxpayerId = this.formData.taxpayerId
      this.invoiceData.address_tel = `${this.formData.address} ${this.formData.tel}`
      this.invoiceData.bankName_acount = `${item.bankName} ${item.bankAccount}`
    },
    clickitemdataType (e) { // e为radio的label值
      e === this.systemLinkMode ? this.systemLinkMode = '' : this.systemLinkMode = e
    },
    choosePerson(obj) {
      this.form = obj;
      this.$refs.choosePerson.open(this.projectManagerGuid ? [this.projectManagerGuid] : []);
    },
    getPersonSelect([personGuid, data, name]) {
      this.projectManagerGuid = personGuid && personGuid.length > 0 ? personGuid[0] : null;
      this.projectManagerName = name || null;
    },
    //删除项目运营人
    delPM() {
      this.projectManagerName = ''
      this.projectManagerGuid = ''
    },
  },
  
};

</script>
<style lang="less" scoped>
.account-radio-class{
  width: 640px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
}
.content {
  padding: 0px;
  margin: 0px;
  padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    padding-bottom: 8px;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .pickerDate{
      width: 300px;
    }
    .el-table{
      margin: 0 60px;
    }
    .el-table--border{
      border-bottom:1px solid #EBEEF5
    }
    .map-a-sty {
  width: 90px;
  height: 34px;
  line-height: 34px;
  color: #4fa1a4;
  padding: 0 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    position: relative;
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left:430px
    }
  }
}
.confirmState{
  background-color: #ccc;
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
  text-align: start;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 422px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.account-class{
  display: flex;
}
.acountMountClass{
  display: flex;
  flex-direction: column;
  margin-top: 13px;
}
.content-main-box{
  height: 100%;
  max-height: 300px;
  
}
.addGoods{
  display:flex;
  justify-content: space-between;
  align-items: center;
  /deep/ .el-button {
    height: 28px;
    margin-right: calc(20% - 60px);
  }

}
.import-btn-tips {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: baseline;
}
.import-step-tip{
  p{
    line-height: 1.5;
  }
}
.import-tip{
  p{
    text-align: start;
  }
}
// 指定运营经理
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}
.designee {
  padding: 3px 6px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #deefef;
  border: 0 none;
  margin-bottom: 4px;
}
</style>
